import { render, staticRenderFns } from "./notifications-button.vue?vue&type=template&id=567c0ae4&scoped=true"
import script from "./notifications-button.vue?vue&type=script&lang=ts"
export * from "./notifications-button.vue?vue&type=script&lang=ts"
import style0 from "./notifications-button.vue?vue&type=style&index=0&id=567c0ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c0ae4",
  null
  
)

export default component.exports